module.exports = __webpack_public_path__ + "static/media/members.a4fa5f32.svg";